'use client';
var classes = {"root":"m_a50f3e58","container":"m_af9188cb","grid":"m_a50a48bc","axis":"m_a507a517","axisLabel":"m_2293801d","tooltip":"m_92b296cd"};

export { classes as default };
//# sourceMappingURL=grid-chart.module.css.mjs.map
